import SelectRadioInputSheet from '../../common/sheets/SelectRadioInputSheet';
import { Pronouns } from '../../common/types/Membership';

interface PronounSelectionSheetProps {
    isOpen: boolean;
    onClose: () => void;
    selectedOption: Pronouns;
    onSelectOption: (Pronouns: Pronouns | null) => void;
}

const PronounSelectionSheet = ({
    isOpen,
    onClose,
    selectedOption,
    onSelectOption,
}: PronounSelectionSheetProps) => {
    return (
        <SelectRadioInputSheet
            title="Pronouns"
            options={Pronouns}
            selectedOption={selectedOption}
            onSelectOption={onSelectOption}
            isOpen={isOpen}
            onClose={onClose}
            toLabelFn={(pronoun: Pronouns) => pronoun}
            includeClearSelectionButton
        />
    );
};

export default PronounSelectionSheet;
